import Icon from "@forwardflow/ui/Icons";
import { useState } from "react";

export const ExampleUSP = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        className="flex items-center justify-between px-10 py-5 text-[12px] border-b border-black/20 cursor-pointer"
      >
        <span className="text-[#B98BE6]/70">Examples:</span>
        <Icon
          name="arrow-down"
          className={`mx-1 rotate-180 fill-white/50 ${
            !isOpen ? "!rotate-0" : ""
          }`}
        />
      </div>
      {isOpen && (
        <div className="px-10 py-4">
          <div className="mb-3">
            <span className="text-[14px]">USP: </span>
            <span className="text-white/70 text-[12px]">
              Agents who focus on luxury homes
            </span>
          </div>
          <div>
            <span className="text-[12px]">Description: </span>
            <span className="text-white/70 text-[12px]">
              Description: We specialize in the luxury home market, providing
              clients with access to exclusive properties and offering
              white-glove service from start to finish. Our deep network ensures
              that buyers and sellers can move confidently in the high-end
              market.
            </span>
          </div>
        </div>
      )}
    </>
  );
};
